import React from 'react'
import styles from './Guests.scss'
import _ from 'lodash'
import {connect} from 'react-redux'
import {getExperienceId} from '../ExperiencesApp/ExperiencesApp'
import {QuickStats} from '../QuickStats'
import {experienceApi, experienceSelectors, experienceActions} from 'data/resources/experiences'
import {loadAllPagesCombined} from 'data/helpers/apiv3'
import {CTA} from 'common/styleguide/CTA'
import {Icon} from 'common/Icon'
import {SectionBox} from 'common/styleguide/SectionBox'
import moment from 'moment'
import Helmet from 'react-helmet'

export class _Guests extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      stats: null,
      appCodeUses: null
    }
  }

  loadData () {
    const {loadExperience} = this.props
    const experienceId = getExperienceId(this.props)

    loadExperience()
    experienceApi.stats(experienceId)
      .then(({stats}) => { this.setState({stats}) })
    loadAllPagesCombined(params => experienceApi.appCodeUses(experienceId, {...params, orderBy: 'id', orderDir: 'desc'}))
      .then(({results: appCodeUses}) => { this.setState({appCodeUses}) })
  }

  componentDidMount () {
    this.loadData()
  }

  componentDidUpdate (prevProps) {
    if (getExperienceId(prevProps) !== getExperienceId(this.props)) {
      this.loadData()
    }
  }

  onExpiredChange = (e) => {
    const {experience} = this.props
    const {appCodeUses} = this.state
    const id = +e.target.value
    const guestToUpdate = appCodeUses.find(x => x.id === id)

    const updateGuest = ({appCodeUse}) => {
      this.setState({
        appCodeUses: _.sortBy(appCodeUses.filter(x => x.id !== id)
          .concat([appCodeUse]), x => x.createdAt)
      })
    }

    let expiresAt = e.target.checked ? new Date() : null
    experienceApi[e.target.checked ? 'expireGuest' : 'unexpireGuest'](experience.id, {appCodeUseId: id})
      .then(updateGuest).catch(() => { updateGuest({appCodeUse: guestToUpdate}) })

    // optimistic update
    updateGuest({appCodeUse: guestToUpdate.set('expiresAt', expiresAt)})
  }

  render () {
    const {experience} = this.props
    const {stats, appCodeUses} = this.state
    const now = new Date()
    const detail = (appCodeUse, key) => (appCodeUse.requestedDetails ? appCodeUse.requestedDetails[key] : '')

    return (
      <div className={styles.Guests}>
        {experience && <Helmet title={experience.name} />}
        <div className={styles.top}>
          <QuickStats totals={stats} className={styles.statsContainer} />
          {experience && appCodeUses && <CTA
            secondary
            margins={false}
            href={`/app_code_uses.csv?parent_type=Experience&parent_id=${experience.id}`}
            className={styles.aSpecificity}>
            <Icon i='md-download' size={20} />Export CSV
          </CTA>}
        </div>
        <SectionBox title='Guests' noPadding>
          {experience && appCodeUses && (
            <table className={styles.guestsTable}>
              <thead>
                <tr>
                  <th>Date Accessed</th>
                  {experience.requireName && <th>First name</th>}
                  {experience.requireName && <th>Last name</th>}
                  {experience.requireEmail && <th>Email address</th>}
                  {experience.requirePhone && <th>Phone number</th>}
                  {experience.requireReferenceId && <th>Reference ID</th>}
                  <th>Expired</th>
                  <th>Expiration date</th>
                </tr>
              </thead>
              <tbody>
                {appCodeUses.map(appCodeUse => (
                  <tr key={appCodeUse.id}>
                    <td>{moment(appCodeUse.createdAt).format('MMM D, YYYY [at] h:mma')}</td>
                    {experience.requireName && <td>{detail(appCodeUse, 'first_name')}</td>}
                    {experience.requireName && <td>{detail(appCodeUse, 'last_name')}</td>}
                    {experience.requireEmail && <td>{detail(appCodeUse, 'email')}</td>}
                    {experience.requirePhone && <td>{detail(appCodeUse, 'phone')}</td>}
                    {experience.requireReferenceId && <td>{detail(appCodeUse, 'reference_id')}</td>}
                    <td>
                      <input type='checkbox' onChange={this.onExpiredChange} value={appCodeUse.id}
                        checked={!!appCodeUse.expiresAt && moment(appCodeUse.expiresAt).isSameOrBefore(now)} />
                    </td>
                    <td>
                      {!appCodeUse.expiresAt && 'Never'}
                      {appCodeUse.expiresAt && moment(appCodeUse.expiresAt).format('MMM D, YYYY [at] h:mma')}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </SectionBox>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const experienceId = getExperienceId(ownProps)

  return {
    loadExperience: () => dispatch(experienceActions.read(experienceId))
  }
}

const mapStateToProps = (state, ownProps) => ({
  experience: experienceSelectors.find(state, getExperienceId(ownProps))
})

export const Guests = connect(
  mapStateToProps,
  mapDispatchToProps
)(_Guests)
